<template>
    <div>
        <report-header
            :title="title"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <QTable
                    :data="result"
                    :columns="formattedColumns"
                    :hide-bottom="true"
                    :rows-per-page-options="[0]"
                    :loading="isLoading"
                    class="q-table"
                >
                    <template
                        v-slot:bottom-row
                        v-if="result.length == 0 && !isLoading && !isError"
                    >
                        <q-tr>
                            <q-td colspan="12">No records available</q-td>
                        </q-tr>
                    </template>
                    <template v-slot:header-cell="{ col }">
                        <th>
                            <strong>{{ col.label }}</strong>
                        </th>
                    </template>
                    <template v-slot:body-cell-client_name="props">
                        <q-td :props="props" class="">
                            <client-name
                                :use-router="USE_CLIENT_MODULE_VUE"
                                :client="generateClientObject(props.row)"
                            />
                        </q-td>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import Report from "@/mixins/report.js";
import "@/css/quasar-table.css";
import { QTable } from "quasar";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import ClientName from "@/components/commons/client-name";
export default {
    components: {
        QTable,
        ClientName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            isLoading: true,
            result: [],
            title: "Cards Stored On File",
            isError: false,
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true"
        };
    },
    mounted() {
        let self = this;
        self.data.filterDateOption = false;
        self.init();
        self.$root.$on("cards-stored-on-file:refresh", function () {
            self.init();
        });
    },

    beforeDestroy: function () {
        this.data.filterDateOption = true;
        this.$root.$off("cards-stored-on-file:refresh");
    },
    methods: {
        async init() {
            let self = this;

            self.isLoading = true;
            self.isError = false;

            await ReportService.getReport(CREPORT.TYPE.CARDS_STORED_ON_FILE)
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.result = res.resource.results;
                        self.title = res.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self._message("Error: Unable to get the report", "danger");
                    self.isError = true;
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        generateClientObject(row) {
            return {
                id: row.client_id,
                name: row.client_name,
                encoded_id: row.client_id,
                isactive: true
            };
        }
    },

    computed: {
        formattedColumns() {
            return [
                {
                    name: "client_name",
                    label: "Client Name",
                    field: "client_name",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "card_network",
                    label: "Card Network",
                    field: "card_network",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "expiration",
                    label: "Expiration",
                    field: "expiration",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "last_four_digit",
                    label: "Last Four Digit",
                    field: "last_four_digit",
                    align: "left",
                    style: "white-space: nowrap"
                },
                {
                    name: "added",
                    label: "Added",
                    field: "added",
                    style: "white-space: nowrap",
                    align: "left"
                },
                {
                    name: "card_status",
                    label: "Card Status",
                    field: "card_status",
                    align: "left",
                    style: "white-space: nowrap",
                    classes: "text-capitalize"
                }
            ];
        }
    }
};
</script>
